<div class="bg-black min-h-[280px] flex p-4 gap-4 flex-wrap" style="background-image: linear-gradient(rgba(35,35,35,0.5), rgba(35,35,35,0.5)), url('https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/mainServices/muestras.png'); background-size: cover;">
    <div class="gap-4 flex flex-col justify-between flex-1 min-w-0">
        <div class="flex flex-col">
            <span class="typography-title-l" style="color: white">{{ 'home.request_samples_for_your_proyects' | translate }}</span>
        </div>
        <app-button [secondary]="true" size="l" class="w-full" (click)="goToSamples()">
            <span class="pt-4">{{ 'order_samples.request_samples' | translate }}</span>
        </app-button>
    </div>
</div>
